import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    createAdminPostForm: false,
    myHtmlSettings: {
      nameSpace: 'html', // Useful to prevent multi-instances CSS conflict
      previewParserPath: '/admin/markdown/preview',
      onShiftEnter: { keepDefault: false, replaceWith: '<br />\n' },
      onCtrlEnter: { keepDefault: false, openWith: '\n<p>', closeWith: '</p>\n' },
      onTab: { keepDefault: false, openWith: '     ' },
      multiline: true,
      markupSet: [
        {
          name: 'Heading 1',
          key: '1',
          openWith: '<h1(!( class="[![Class]!]")!)>',
          closeWith: '</h1>',
          placeHolder: 'Your title here...',
        },
        {
          name: 'Heading 2',
          key: '2',
          openWith: '<h2(!( class="[![Class]!]")!)>',
          closeWith: '</h2>',
          placeHolder: 'Your title here...',
        },
        {
          name: 'Heading 3',
          key: '3',
          openWith: '<h3(!( class="[![Class]!]")!)>',
          closeWith: '</h3>',
          placeHolder: 'Your title here...',
        },
        {
          name: 'Heading 4',
          key: '4',
          openWith: '<h4(!( class="[![Class]!]")!)>',
          closeWith: '</h4>',
          placeHolder: 'Your title here...',
        },
        {
          name: 'Heading 5',
          key: '5',
          openWith: '<h5(!( class="[![Class]!]")!)>',
          closeWith: '</h5>',
          placeHolder: 'Your title here...',
        },
        {
          name: 'Heading 6',
          key: '6',
          openWith: '<h6(!( class="[![Class]!]")!)>',
          closeWith: '</h6>',
          placeHolder: 'Your title here...',
        },
        { name: 'Paragraph', openWith: '<p(!( class="[![Class]!]")!)>', closeWith: '</p>' },
        { separator: '---------------' },
        {
          name: 'Bold', key: 'B', openWith: '<strong>', closeWith: '</strong>',
        },
        {
          name: 'Italic', key: 'I', openWith: '<em>', closeWith: '</em>',
        },
        {
          name: 'Stroke through', key: 'S', openWith: '<del>', closeWith: '</del>',
        },
        { separator: '---------------' },
        { name: 'Ul', openWith: '<ul>\n', closeWith: '</ul>\n' },
        { name: 'Ol', openWith: '<ol>\n', closeWith: '</ol>\n' },
        { name: 'Li', openWith: '<li>', closeWith: '</li>' },
        { separator: '---------------' },
        { name: 'Picture', key: 'P', replaceWith: '<img src="[![Source:!:http://]!]" alt="[![Alternative text]!]" />' },
        {
          name: 'Link',
          key: 'L',
          openWith: '<a href="[![Link:!:http://]!]"(!( title="[![Title]!]")!)>',
          closeWith: '</a>',
          placeHolder: 'Your text to link...',
        },
        { separator: '---------------' },
        { name: 'Clean', replaceWith(h) { return h.selection.replace(/<(.*?)>/g, ''); } },
        { name: 'Preview', call: 'preview', className: 'preview' },
      ],
    },
  },
  mutations: {
    createAdminPostFormShow(state) {
      state.createAdminPostForm = true;
    },
    createAdminPostFormHide(state) {
      state.createAdminPostForm = false;
    },
  },
});
